// import React, { useState, useEffect } from "react";
// import Header from "../Layout/Header";
// import { Link, useParams } from "react-router-dom";
// import Footer from "../Layout/Footer";
// import { BaseUrl } from "../..";
// import { Helmet } from "react-helmet-async";

// function JodiPanel() {
//   const [jodiData, setJodiData] = useState({});
//   const [showName, setShowName] = useState("");
//   const [dynamicTitle, setDynamicTitle] = useState({});
//   const [loading, setLoading] = useState(false);
//   const { JodiAlias } = useParams();

//   const API_URL_J = `${BaseUrl}day-wise-jodi-data`;

//   const fetchPanelData = async (alias) => {
//     setLoading(true);
//     try {
//       const response = await fetch(API_URL_J, {
//         method: "POST",
//         headers: {
//           "Content-Type": "application/json",
//         },
//         body: JSON.stringify({ JodiAlias: alias }),
//       });

//       const data = await response.json();

//       if (data.status === "Success") {
//         setDynamicTitle(data);
//         setShowName(data.ShowName);
//         setJodiData(data.data);
//       } else {
//         setJodiData({});
//       }
//     } catch (error) {
//       console.log("Fetch Error:", error.message);
//     }
//     setLoading(false);
//   };

//   useEffect(() => {
//     if (JodiAlias) {
//       fetchPanelData(JodiAlias);
//     }
//   }, [JodiAlias]);

//   const isDataAvailable = Object.keys(jodiData).length > 0;

//   const getLatestDaywiseData = (data) => {
//     const dayMap = {
//       Monday: [],
//       Tuesday: [],
//       Wednesday: [],
//       Thursday: [],
//       Friday: [],
//       Saturday: [],
//       Sunday: [],
//     };

//     Object.entries(data).forEach(([date, value]) => {
//       const { day, open, close } = value;
//       if (dayMap.hasOwnProperty(day)) {
//         dayMap[day].push({
//           open: open?.akhar ?? "*",
//           close: close?.akhar ?? "*",
//           openIsFlag: open?.isFlag ?? "",
//           closeIsFlag: close?.isFlag ?? "",
//         });
//       }
//     });

//     return dayMap;
//   };

//   return (
//     <>
//       <Helmet>
//         <title>Home Page - Madhushree.in</title> {/* Specific title for Home */}
//         <meta
//           name="description"
//           content="Explore various panels and jodi information on Madhushree.in."
//         />
//         {/* You can add more meta tags here, like keywords, author, etc. */}
//         <link rel="canonical" href="https://www.madhushree.in/" />
//         {/* Example of an Open Graph tag for social media sharing */}
//         <meta
//           property="og:title"
//           content="Madhushree.in - Your trusted source"
//         />
//         <meta
//           property="og:description"
//           content="Official website of Madhushree.in"
//         />
//         <meta property="og:url" content="https://www.madhushree.in/" />
//         <meta property="og:type" content="website" />
//       </Helmet>
//       <Header />

//       <div className="layout_table">
//         <h6 className="result ms-3">
//           <Link to="/">/HOME</Link>
//         </h6>
//       </div>
//       <div className="layout_table">
//         <div className="row">
//           <div className="col-md-12">
//             <h6 className="text_heading">{showName} Jodi Chart</h6>
//             <div className="table-responsive">
//               {loading ? (
//                 <div className="text-center my-4">
//                   <div className="spinner-border text-primary" role="status">
//                     <span className="visually-hidden"></span>
//                   </div>
//                 </div>
//               ) : (
//                 <table className="jodi_table">
//                   {isDataAvailable ? (
//                     <>
//                       <thead>
//                         <tr>
//                           <th>Mon</th>
//                           <th>Tue</th>
//                           <th>Wed</th>
//                           <th>Thu</th>
//                           <th>Fri</th>
//                           <th>Sat</th>
//                           <th>Sun</th>
//                         </tr>
//                       </thead>
//                       <tbody>
//                         {[
//                           ...Array(
//                             Math.max(
//                               ...Object.values(
//                                 getLatestDaywiseData(jodiData)
//                               ).map((day) => day.length)
//                             )
//                           ),
//                         ].map((_, rowIndex) => (
//                           <tr key={rowIndex}>
//                             {[
//                               "Monday",
//                               "Tuesday",
//                               "Wednesday",
//                               "Thursday",
//                               "Friday",
//                               "Saturday",
//                               "Sunday",
//                             ].map((day) => {
//                               const dayEntries =
//                                 getLatestDaywiseData(jodiData)[day];
//                               const entry = dayEntries[rowIndex] || {};
//                               return (
//                                 <td key={day}>
//                                   <div
//                                     style={{
//                                       color:
//                                         entry?.openIsFlag === 1
//                                           ? "red"
//                                           : "black",
//                                     }}
//                                   >
//                                     <span>{entry.open}</span>{" "}
//                                     <span>{entry.close}</span>
//                                   </div>
//                                 </td>
//                               );
//                             })}
//                           </tr>
//                         ))}
//                       </tbody>
//                     </>
//                   ) : (
//                     <tbody>
//                       <tr>
//                         <td colSpan="7" className="no-data-text">
//                           No Data Found
//                         </td>
//                       </tr>
//                     </tbody>
//                   )}
//                 </table>
//               )}
//             </div>
//           </div>
//         </div>
//       </div>
//       <div className="refresh-button-wrapper">
//         <button
//           onClick={() => window.location.reload()}
//           className="refresh-button"
//         >
//           Refresh
//         </button>
//       </div>
//       <div className="support-box">
//         <p>
//           <em>Email for any inquiries Or Support:</em>
//         </p>
//         <div className="email-button">madhushreeofficia13@gmaiI.com</div>
//       </div>
//       <Footer />
//     </>
//   );
// }

// export default JodiPanel;

import React, { useState, useEffect } from "react";
import Header from "../Layout/Header";
import { Link, useParams } from "react-router-dom";
import Footer from "../Layout/Footer";
import { BaseUrl } from "../..";
import { Helmet } from "react-helmet-async"; // Make sure this is react-helmet-async

function JodiPanel() {
  const [jodiData, setJodiData] = useState({});
  const [showName, setShowName] = useState("");
  const [dynamicTitle, setDynamicTitle] = useState(null); // Initialize as null to clearly indicate no data yet
  const [loading, setLoading] = useState(false);
  const { JodiAlias } = useParams();

  const API_URL_J = `${BaseUrl}day-wise-jodi-data`;

  const fetchPanelData = async (alias) => {
    setLoading(true);
    try {
      const response = await fetch(API_URL_J, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ JodiAlias: alias }),
      });

      const data = await response.json();

      if (data.status === "Success") {
        setDynamicTitle(data); // Assuming 'data' itself contains useful info like showName for title
        setShowName(data.ShowName);
        setJodiData(data.data);
      } else {
        setJodiData({});
        setShowName(""); // Clear showName if data is not successful
        setDynamicTitle(null); // Clear dynamicTitle if data is not successful
      }
    } catch (error) {
      console.log("Fetch Error:", error.message);
      setJodiData({});
      setShowName("");
      setDynamicTitle(null);
    }
    setLoading(false);
  };

  useEffect(() => {
    if (JodiAlias) {
      fetchPanelData(JodiAlias);
    }
  }, [JodiAlias]);

  const isDataAvailable = Object.keys(jodiData).length > 0;

  const getLatestDaywiseData = (data) => {
    const dayMap = {
      Monday: [],
      Tuesday: [],
      Wednesday: [],
      Thursday: [],
      Friday: [],
      Saturday: [],
      Sunday: [],
    };

    Object.entries(data).forEach(([date, value]) => {
      const { day, open, close } = value;
      if (dayMap.hasOwnProperty(day)) {
        dayMap[day].push({
          open: open?.akhar ?? "*",
          close: close?.akhar ?? "*",
          openIsFlag: open?.isFlag ?? "",
          closeIsFlag: close?.isFlag ?? "",
        });
      }
    });

    return dayMap;
  };

  // Define dynamic content for Helmet
  const pageTitle = showName
    ? `${showName} Jodi Chart | Madhushree.in`
    : `Jodi Chart | Madhushree.in`;
  const pageDescription = showName
    ? `View the latest results and comprehensive chart for ${showName} Jodi.`
    : "Explore detailed Jodi charts and results.";
  const canonicalUrl = `https://www.madhushree.in/#/jodi/${JodiAlias || ""}`;

  return (
    <>
      <Helmet>
        <title>{pageTitle}</title>
        <meta name="description" content={pageDescription} />
        <link rel="canonical" href={canonicalUrl} />

        {/* Open Graph (Facebook, LinkedIn, etc.) */}
        <meta property="og:title" content={pageTitle} />
        <meta property="og:description" content={pageDescription} />
        <meta property="og:url" content={canonicalUrl} />
        <meta property="og:type" content="website" />
        <meta property="og:site_name" content="Madhushree.in" />
        <meta
          property="og:image"
          content="https://www.madhushree.in/assets/jodi-preview.png"
        />
        <meta property="og:image:width" content="1200" />
        <meta property="og:image:height" content="630" />

        {/* Twitter Card (for Twitter link preview) */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content={pageTitle} />
        <meta name="twitter:description" content={pageDescription} />
        <meta
          name="twitter:image"
          content="https://www.madhushree.in/assets/jodi-preview.png"
        />

        {/* Optional SEO */}
        {dynamicTitle?.keywords && (
          <meta name="keywords" content={dynamicTitle.keywords} />
        )}
      </Helmet>
      <Header />

      <div className="layout_table">
        <h6 className="result ms-3">
          <Link to="/">/HOME</Link>
        </h6>
      </div>
      <div className="layout_table">
        <div className="row">
          <div className="col-md-12">
            <h6 className="text_heading">{showName} Jodi Chart</h6>
            <div className="table-responsive">
              {loading ? (
                <div className="text-center my-4">
                  <div className="spinner-border text-primary" role="status">
                    <span className="visually-hidden"></span>
                  </div>
                </div>
              ) : (
                <table className="jodi_table">
                  {isDataAvailable ? (
                    <>
                      <thead>
                        <tr>
                          <th>Mon</th>
                          <th>Tue</th>
                          <th>Wed</th>
                          <th>Thu</th>
                          <th>Fri</th>
                          <th>Sat</th>
                          <th>Sun</th>
                        </tr>
                      </thead>
                      <tbody>
                        {[
                          ...Array(
                            Math.max(
                              ...Object.values(
                                getLatestDaywiseData(jodiData)
                              ).map((day) => day.length)
                            )
                          ),
                        ].map((_, rowIndex) => (
                          <tr key={rowIndex}>
                            {[
                              "Monday",
                              "Tuesday",
                              "Wednesday",
                              "Thursday",
                              "Friday",
                              "Saturday",
                              "Sunday",
                            ].map((day) => {
                              const dayEntries =
                                getLatestDaywiseData(jodiData)[day];
                              const entry = dayEntries[rowIndex] || {};
                              return (
                                <td key={day}>
                                  <div
                                    style={{
                                      color:
                                        entry?.openIsFlag === 1
                                          ? "red"
                                          : "black",
                                    }}
                                  >
                                    <span>{entry.open}</span>{" "}
                                    <span>{entry.close}</span>
                                  </div>
                                </td>
                              );
                            })}
                          </tr>
                        ))}
                      </tbody>
                    </>
                  ) : (
                    <tbody>
                      <tr>
                        <td colSpan="7" className="no-data-text">
                          No Data Found
                        </td>
                      </tr>
                    </tbody>
                  )}
                </table>
              )}
            </div>
          </div>
        </div>
      </div>
      <div className="refresh-button-wrapper">
        <button
          onClick={() => window.location.reload()}
          className="refresh-button"
        >
          Refresh
        </button>
      </div>
      <div className="support-box">
        <p>
          <em>Email for any inquiries Or Support:</em>
        </p>
        <div className="email-button">madhushreeofficia13@gmaiI.com</div>
      </div>
      <Footer />
    </>
  );
}

export default JodiPanel;
